module.exports = __webpack_public_path__ + "img/w3_spinner_black.72a67cba.png";